import React from 'react'
import {Modal} from 'antd';
import { Container } from '../styles';

export const ScreenAcc = (props) => {
    return (
        <Modal visible={props.visible} onCancel={props.onCancel}
        footer={null}
                centered>
            <Container>
                {props.children}
            </Container>

        </Modal>
    )
}
